import { ChartColors, ColorShade } from '@/types/theme';

import { useTheme } from '@mui/material';

export const useChartColors = (): string[] => {
  const theme = useTheme();

  const hues: (keyof ChartColors)[] = [
    'deepSeaNavy',
    'fireOrange',
    'earthGreen',
    'amber',
    'skyBlue',
    'aqua',
    'stoneGrey',
    'magenta',
  ];

  const shades: (keyof ColorShade)[] = ['c100', 'c75', 'c50', 'c25'];

  return shades.flatMap((shade) =>
    hues
      .filter((hue) => hue !== 'fireOrange' || shade === 'c100') // fireOrange only in c100
      .map((hue) => theme.palette.chartColors[hue][shade]),
  );
};
